import { useCallback, useMemo } from 'react';
import Helmet from 'react-helmet'
import { useParams } from 'react-router-dom'

import { DefaultSheet } from 'twyne-new.ui'

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history'

import Form from '../components/Form'
import { ValidatorProvider, useValidatorStore } from '../store';

const ValidatorForm = ({ validatorId, onSubmit, onCancel }) => {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit } } = useValidatorStore()
  const { handleSuccess, handleError } = useAppAlert()
  const entityOrigin = useMemo(() => !onSubmit, [onSubmit])

  useLoad(entityOrigin ? id : validatorId)
  const handleSubmit = useSubmit()

  const handleCloseSidebar = useCallback(() => {
    onCancel ? onCancel() : history.push('/settings/validators')
  }, [onCancel])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      const data = await handleSubmit(payload)
      handleCloseSidebar()
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Validator ${message}.`)
      onSubmit && onSubmit(payload.id || data.id)
    } catch {
      handleError('Error', 'Validator was not saved.')
    }
  }, [handleSubmit, handleCloseSidebar, onSubmit, handleSuccess, handleError])

  if (!item) {
    return null
  }

  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleCloseSidebar() }}
      title={item.id ? 'User Validator' : 'Add Validator'}
    >
      <Helmet title="Validator" />
      <Form entityOrigin={entityOrigin} data={item} onSubmit={handleSubmitAndClose} onCancel={handleCloseSidebar} />
    </DefaultSheet>
  </>
}

export default function ValidatorFormLayout(props) {
  return <ValidatorProvider>
    <ValidatorForm {...props} />
  </ValidatorProvider>
}
